import dayjs from "dayjs";
import { getUserValueFromField } from "../../helpers/cosmos-field-value-extractor";

export const fetchDetailsForUsersIndividually = async (accountIds) => {
  try {
    const promises = accountIds.map(async (accountId) => {
      const res = await window.AP.request(
        `/rest/api/user?accountId=${accountId}`
      );
      const resData = JSON.parse(res.body);
      return resData;
    });

    const response = await Promise.all(promises);
    return response;
  } catch (error) {
    return [];
  }
};

export const getUsersDetails = async ({
  records,
  databaseFieldId,
  fields = [],
  titleFieldId = "",
  footerFieldId = "",
}) => {
  try {
    const accountIds = records.map((user) => user.accountId);
    const usersWithDetails = await fetchDetailsForUsersIndividually(accountIds);
    const formattedUsers = usersWithDetails
      .map((user) => {
        const userValues = records.find(
          (r) => r.accountId === user.accountId
        )?.values;

        const dateField = userValues[`recurring_${databaseFieldId}`];
        if (!dateField) return null;

        const dateFieldUnix = dayjs.unix(dateField);
        const currentYear = dayjs().year();
        const dateFieldUnixCurrentYear = dateFieldUnix.set("year", currentYear);

        const today = dayjs().startOf("day");
        const dateFieldForComparison = dateFieldUnixCurrentYear.startOf("day");

        const daysLeftFromCurrentYear = dateFieldForComparison.diff(
          today,
          "day"
        );
        const yearsLeftFromCurrentYear = Math.abs(
          dateFieldUnix.diff(dateFieldUnixCurrentYear, "year")
        );

        return {
          accountId: user.accountId,
          name: user.displayName,
          avatarUrl: `${window.AP._hostOrigin}${user.profilePicture.path}`,
          formattedDateField: dateFieldUnix.format("MMM D"),
          daysLeft: daysLeftFromCurrentYear,
          yearsLeft: yearsLeftFromCurrentYear,
          hasBirthday: !!dateField,
          title: getUserValueFromField(userValues || {}, fields, titleFieldId),
          footer: getUserValueFromField(
            userValues || {},
            fields,
            footerFieldId
          ),
        };
      })
      .filter(Boolean);

    const sortedUsers = formattedUsers.sort((a, b) => {
      const getSortWeight = (user) => {
        if (user.daysLeft < 0) return 0;
        if (user.daysLeft === 0) return 1;
        return 2;
      };

      const weightA = getSortWeight(a);
      const weightB = getSortWeight(b);

      return weightA !== weightB ? weightA - weightB : a.daysLeft - b.daysLeft;
    });

    return sortedUsers;
  } catch (error) {
    console.log("error", error);
    console.log("Can not fetch data for users individually.");
    return [];
  }
};
